// 蓝湖上设计稿自定义为1920px 测量值直接写入即可

// 仅保留移动端rem适配逻辑
const baseSize = 35; // 移动端基准值（对应350px设计稿）

// 设置rem函数
function setRem() {
  // 仅在移动设备上应用rem适配
  if (window.innerWidth < 768) {
    const scale = window.innerWidth / 350; // 基于350px设计稿计算缩放比例
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + "px";
  } else {
    // PC端不设置rem，使用vw适配
    document.documentElement.style.fontSize = "16px"; // 重置为默认值
  }
}
setRem();
window.onresize = function () {
  setRem();
};
